// Best-effort id→name lookups for rooms + PCs so the UI shows names, not UUIDs.
// Column names vary across the shared DB, so we read whole rows and derive a
// label defensively; on any error we simply fall back to short UUIDs.
import { supabase } from '@/lib/supabase';

type LookupMap = Map<string, string>;

let roomsCache: LookupMap | null = null;
let pcsCache: LookupMap | null = null;

function label(row: any): string {
  return row.name ?? row.hostname ?? row.display_name ?? row.room_name ?? row.id;
}

async function load(schema: string, table: string): Promise<LookupMap> {
  const map: LookupMap = new Map();
  try {
    const { data, error } = await supabase.schema(schema).from(table).select('*');
    if (error) throw error;
    for (const row of data ?? []) map.set(row.id, label(row));
  } catch {
    /* readable-name lookup is optional; fall back to ids */
  }
  return map;
}

export async function getRooms(): Promise<LookupMap> {
  if (!roomsCache) roomsCache = await load('public', 'rooms');
  return roomsCache;
}

export async function getPcs(): Promise<LookupMap> {
  if (!pcsCache) pcsCache = await load('infra', 'pc_instances');
  return pcsCache;
}

export function shortId(id: string | null | undefined): string {
  return id ? id.slice(0, 8) : '—';
}
